/**
 * Splits items into consecutive groups. Without explicit sizes, groups of `fallbackSize` are used.
 */
export const groupBySizes = <T>(items: readonly T[], sizes?: readonly number[], fallbackSize = 3): T[][] => {
  const groups: T[][] = [];
  let index = 0;

  if (!sizes) {
    while (index < items.length) {
      groups.push([...items.slice(index, index + fallbackSize)]);
      index += fallbackSize;
    }

    return groups;
  }

  sizes.forEach((size) => {
    if (index < items.length) {
      groups.push([...items.slice(index, index + size)]);
    }
    index += size;
  });

  return groups;
};
